import React from 'react';
import PropTypes from 'prop-types';

import VideoArea from '../../../../../components/Atoms/VideoArea';
import getYoutubeId from "../../../../getYoutubeId";
import { classNames, youtubeUrlRegex } from './Constants';

const toEmbedVideo = () => 
{
    const Wrapper = ({ name = '', type, attribs = {}, children = [] }) => 
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'figure') return null;
        if (!attribs?.class?.split(' ').includes(classNames.WP_BLOCK_EMBED_YOUTUBE)) return null;
        
        const content = children.find(
            (child) => child.type === 'tag' && child.name === 'div' && child?.attribs?.class?.includes(classNames.WP_BLOCK_EMBED_WRAPPER)
        );

        if (!content) return null;
        const iframeAttributes = content?.children?.find(item => item?.type === 'tag' && item?.name === 'iframe');
        const figureAttributes = content?.children.find(item => item?.type === 'text' && youtubeUrlRegex.test(item?.data));

        if (!iframeAttributes && !figureAttributes) return null;
        let videoId = null;
        
        if (iframeAttributes?.attribs?.src) 
        {
            videoId = getYoutubeId(iframeAttributes?.attribs?.src)
        }
        else if (figureAttributes.data) 
        {
            videoId = getYoutubeId(figureAttributes.data.replace(/\n/g, '').trim());
        }
        
        if (!videoId) return null;

        return <VideoArea videoId={videoId}  snippet={iframeAttributes?.attribs} />
    };

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['figure']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
        }),
        children: PropTypes.node,
    };

    return Wrapper;
};

export default toEmbedVideo;
